"use strict";
module.exports = {
    entityModel: 'article',
    events: {
        ARTICLE_UPDATED: 'ARTICLE_UPDATED',
        ARTICLE_CREATED: 'ARTICLE_CREATED',
        ARTICLE_ACTIVATED: 'ARTICLE_ACTIVATED',
        ARTICLE_DEACTIVATED: 'ARTICLE_DEACTIVATED',
        ARTICLE_CAMPAIGN_STARTED: 'ARTICLE_CAMPAIGN_STARTED',
        ARTICLE_CAMPAIGN_ENDED: 'ARTICLE_CAMPAIGN_ENDED',
        ARTICLE_PUBLISHED_ON_WHITELABEL: 'ARTICLE_PUBLISHED_ON_WHITELABEL',
        ARTICLE_PUBLISHED_ON_OUR_STORE: 'ARTICLE_PUBLISHED_ON_OUR_STORE',
        ARTICLE_PUBLISHED_ON_PRO: 'ARTICLE_PUBLISHED_ON_PRO',
        ARTICLE_PUBLISHED_ON_STOCKFILLER: 'ARTICLE_PUBLISHED_ON_STOCKFILLER',
        ARTICLE_UNPUBLISHED_ON_WHITELABEL: 'ARTICLE_UNPUBLISHED_ON_WHITELABEL',
        ARTICLE_UNPUBLISHED_ON_OUR_STORE: 'ARTICLE_UNPUBLISHED_ON_OUR_STORE',
        ARTICLE_UNPUBLISHED_ON_PRO: 'ARTICLE_UNPUBLISHED_ON_PRO',
        ARTICLE_UNPUBLISHED_ON_STOCKFILLER: 'ARTICLE_UNPUBLISHED_ON_STOCKFILLER',
        ARTICLE_STOCKCHANGE: 'ARTICLE_STOCKCHANGE',
        ARTICLE_BATCH_BLOCKED: 'ARTICLE_BATCH_BLOCKED',
        ARTICLE_BATCH_UNBLOCKED: 'ARTICLE_BATCH_UNBLOCKED',
        ARTICLE_QUANTITY_IN_EXACTA_STOCK_CHANGED: 'ARTICLE_QUANTITY_IN_EXACTA_STOCK_CHANGED',
        ARTICLE_CUSTOMER_SUB_UNIT_SPECIFIC_ARTICLE_CREATED: 'ARTICLE_CUSTOMER_SUB_UNIT_SPECIFIC_ARTICLE_CREATED',
        ARTICLE_CUSTOMER_SUB_UNIT_SPECIFIC_ARTICLE_UPDATED: 'ARTICLE_CUSTOMER_SUB_UNIT_SPECIFIC_ARTICLE_UPDATED',
        ARTICLE_METADATA_CHANGED: 'ARTICLE_METADATA_CHANGED',
        ARTICLE_LABEL_ADDED: 'ARTICLE_LABEL_ADDED',
        ARTICLE_LABEL_REMOVED: 'ARTICLE_LABEL_REMOVED',
        ARTICLE_QUANTITY_IN_DLP_STOCK_CHANGED: 'ARTICLE_QUANTITY_IN_DLP_STOCK_CHANGED',
    },
    actions: {
        get: 'v1.article.get',
        list: 'v1.article.list',
        setOwningSupplierOrganization: 'v1.article.setOwningSupplierOrganization',
        handlePublications: 'v1.article.handlePublications',
        publishOnExacta: 'v1.article.publishOnExacta',
        deactivate: 'v1.article.deactivate',
        activate: 'v1.article.activate',
        markAsOutOfStock: 'v1.article.markAsOutOfStock',
        markAsInStock: 'v1.article.markAsInStock',
        startCampaign: 'v1.article.startCampaign',
        endCampaign: 'v1.article.endCampaign',
        setSupplierArticleNumber: 'v1.article.setSupplierArticleNumber',
        testGuardedActionCall: 'v1.article.testGuardedActionCall',
        setVindenStockQuantity: 'v1.article.setVindenStockQuantity',
        setBatchQuantity: 'v1.article.setBatchQuantity',
        updateStockQuantities: 'v1.article.updateStockQuantities',
        updateExactaStockQuantities: 'v1.article.updateExactaStockQuantities',
        updateFortnoxStockQuantities: 'v1.article.updateFortnoxStockQuantities',
        ensureInvariants: 'v1.article.ensureInvariants',
        blockBatch: 'v1.article.blockBatch',
        unblockBatch: 'v1.article.unblockBatch',
        blockBatchesOnOrderFullfillmentCenter: 'v1.article.blockBatchesOnOrderFullfillmentCenter',
        unblockBatchesOnOrderFullfillmentCenter: 'v1.article.unblockBatchesOnOrderFullfillmentCenter',
        blockAllBatches: 'v1.article.blockAllBatches',
        unblockAllBatches: 'v1.article.unblockAllBatches',
        updateFromExternalSource: 'v1.article.updateFromExternalSource',
        writeArticle: 'v1.article.writeArticle',
        importArticle: 'v1.article.importArticle',
        addFlaivyImages: 'v1.article.addFlaivyImages',
        updateStockKeepingUnits: 'v1.article.updateStockKeepingUnits',
        fortnoxArticle: 'v1.article.fortnoxArticle',
        editArticleBatches: 'v1.article.editArticleBatches',
        updateStockQuantitiesManually: 'v1.article.updateStockQuantitiesManually',
        privabImportArticle: 'v1.article.privabImportArticle',
        ensureArticleBatchesForOfc: 'v1.article.ensureArticleBatchesForOfc',
        addLabel: 'v1.article.addLabel',
        removeLabel: 'v1.article.removeLabel',
        upsert: 'v1.article.upsert',
        upsertWhenEmpty: 'v1.article.upsertWhenEmpty',
        updateWhenEmpty: 'v1.article.updateWhenEmpty',
        update: 'v1.article.update',
    },
    varuTypDimensionCodes: {
        0: '0',
        '0050': '0050',
        '0051': '0051',
        '0052': '0052',
        '0053': '0053',
        '0054': '0054',
        '0055': '0055',
        '0056': '0056',
        '0057': '0057',
        '0058': '0058',
        '0059': '0059',
        '0060': '0060',
        '0061': '0061',
        '0062': '0062',
        '0063': '0063',
        '0064': '0064',
        '0065': '0065',
        '0066': '0066',
        '0067': '0067',
        '0068': '0068',
        '0069': '0069',
        '0070': '0070',
        '0071': '0071',
        '0072': '0072',
        '0073': '0073',
        '0076': '0076',
        '0077': '0077',
        '0078': '0078',
        '0079': '0079',
        '0080': '0080',
        '0081': '0081',
        '0082': '0082',
        '0083': '0083',
        '0084': '0084',
        '0085': '0085',
        '0086': '0086',
        '0087': '0087',
        '0088': '0088',
        '0089': '0089',
        '0090': '0090',
        '0091': '0091',
        '0095': '0095',
        '0096': '0096',
        '0097': '0097',
        '0098': '0098',
        '0099': '0099',
        '0101': '0101',
        '0102': '0102',
        '0105': '0105',
        '0109': '0109',
        '0110': '0110',
        '0117': '0117',
        '0147': '0147',
        '0177': '0177',
        '0206': '0206',
        '0217': '0217',
        '0245': '0245',
        '0300': '0300',
        '0302': '0302',
        '0306': '0306',
        '0307': '0307',
        '0308': '0308',
        '0310': '0310',
        '0326': '0326',
        '0328': '0328',
        '0342': '0342',
        '0344': '0344',
        '0345': '0345',
        '0350': '0350',
        '0352': '0352',
        '0358': '0358',
        '0360': '0360',
        '0362': '0362',
        '0364': '0364',
        '0366': '0366',
        '0368': '0368',
        '0376': '0376',
        '0384': '0384',
        '0392': '0392',
        '0395': '0395',
        '0397': '0397',
        '0414': '0414',
        '0493': '0493',
        '0575': '0575',
        '0592': '0592',
        '0667': '0667',
        '0670': '0670',
        '0700': '0700',
        '0760': '0760',
        '0764': '0764',
        '0770': '0770',
        '0772': '0772',
        '0773': '0773',
        '0777': '0777',
        '0779': '0779',
        '0789': '0789',
        '0790': '0790',
        '0889': '0889',
        '0941': '0941',
        '0996': '0996',
        '0997': '0997',
        '0999': '0999',
        1: '1',
        1064: '1064',
        1101: '1101',
        1109: '1109',
        1110: '1110',
        1111: '1111',
        1112: '1112',
        1113: '1113',
        1114: '1114',
        1115: '1115',
        1116: '1116',
        1117: '1117',
        1118: '1118',
        1119: '1119',
        1120: '1120',
        1121: '1121',
        1122: '1122',
        1123: '1123',
        1124: '1124',
        1125: '1125',
        1126: '1126',
        1128: '1128',
        1129: '1129',
        1130: '1130',
        1131: '1131',
        1132: '1132',
        1133: '1133',
        1134: '1134',
        1135: '1135',
        1136: '1136',
        1137: '1137',
        1138: '1138',
        1139: '1139',
        1140: '1140',
        1141: '1141',
        1142: '1142',
        1144: '1144',
        1145: '1145',
        1146: '1146',
        1147: '1147',
        1148: '1148',
        1149: '1149',
        1150: '1150',
        1151: '1151',
        1152: '1152',
        1153: '1153',
        1154: '1154',
        1155: '1155',
        1159: '1159',
        1170: '1170',
        1172: '1172',
        1326: '1326',
        1392: '1392',
        1393: '1393',
        1400: '1400',
        1402: '1402',
        1404: '1404',
        1406: '1406',
        1410: '1410',
        1414: '1414',
        1421: '1421',
        1493: '1493',
        1667: '1667',
        1678: '1678',
        1996: '1996',
        2: '2',
        2101: '2101',
        2102: '2102',
        2142: '2142',
        2160: '2160',
        2161: '2161',
        2162: '2162',
        2163: '2163',
        2164: '2164',
        2165: '2165',
        2166: '2166',
        2167: '2167',
        2168: '2168',
        2169: '2169',
        2170: '2170',
        2171: '2171',
        2173: '2173',
        2174: '2174',
        2175: '2175',
        2176: '2176',
        2177: '2177',
        2178: '2178',
        2179: '2179',
        2180: '2180',
        2181: '2181',
        2182: '2182',
        2183: '2183',
        2184: '2184',
        2185: '2185',
        2186: '2186',
        2188: '2188',
        2189: '2189',
        2190: '2190',
        2191: '2191',
        2192: '2192',
        2193: '2193',
        2194: '2194',
        2195: '2195',
        2196: '2196',
        2198: '2198',
        2199: '2199',
        2200: '2200',
        2201: '2201',
        2202: '2202',
        2203: '2203',
        2204: '2204',
        2206: '2206',
        2208: '2208',
        2210: '2210',
        2211: '2211',
        2212: '2212',
        2213: '2213',
        2214: '2214',
        2215: '2215',
        2216: '2216',
        2217: '2217',
        2218: '2218',
        2219: '2219',
        2220: '2220',
        2221: '2221',
        2222: '2222',
        2223: '2223',
        2224: '2224',
        2225: '2225',
        2226: '2226',
        2227: '2227',
        2228: '2228',
        2229: '2229',
        2230: '2230',
        2231: '2231',
        2232: '2232',
        2233: '2233',
        2234: '2234',
        2235: '2235',
        2236: '2236',
        2237: '2237',
        2238: '2238',
        2239: '2239',
        2240: '2240',
        2241: '2241',
        2242: '2242',
        2243: '2243',
        2244: '2244',
        2245: '2245',
        2249: '2249',
        2260: '2260',
        2261: '2261',
        2292: '2292',
        2294: '2294',
        2308: '2308',
        2326: '2326',
        2397: '2397',
        2400: '2400',
        2450: '2450',
        2460: '2460',
        2472: '2472',
        2474: '2474',
        2475: '2475',
        2482: '2482',
        2484: '2484',
        2490: '2490',
        2492: '2492',
        2493: '2493',
        2494: '2494',
        2495: '2495',
        2499: '2499',
        2564: '2564',
        2567: '2567',
        2575: '2575',
        2713: '2713',
        2950: '2950',
        2996: '2996',
        3: '3',
        3101: '3101',
        3102: '3102',
        3108: '3108',
        3186: '3186',
        32: '32',
        3326: '3326',
        3396: '3396',
        3397: '3397',
        3472: '3472',
        3493: '3493',
        3500: '3500',
        3510: '3510',
        3511: '3511',
        3599: '3599',
        3670: '3670',
        3675: '3675',
        3680: '3680',
        3681: '3681',
        3682: '3682',
        3683: '3683',
        3685: '3685',
        3686: '3686',
        3747: '3747',
        3748: '3748',
        3749: '3749',
        3750: '3750',
        3751: '3751',
        3752: '3752',
        3754: '3754',
        3755: '3755',
        3756: '3756',
        3757: '3757',
        3758: '3758',
        3759: '3759',
        3760: '3760',
        3761: '3761',
        3762: '3762',
        3764: '3764',
        3766: '3766',
        3767: '3767',
        3770: '3770',
        3772: '3772',
        3775: '3775',
        3776: '3776',
        3778: '3778',
        3779: '3779',
        3780: '3780',
        3782: '3782',
        3784: '3784',
        3785: '3785',
        3786: '3786',
        3788: '3788',
        3789: '3789',
        3790: '3790',
        3798: '3798',
        3800: '3800',
        3804: '3804',
        3805: '3805',
        3807: '3807',
        3808: '3808',
        3809: '3809',
        3810: '3810',
        3811: '3811',
        3812: '3812',
        3813: '3813',
        3814: '3814',
        3815: '3815',
        3816: '3816',
        3817: '3817',
        3818: '3818',
        3826: '3826',
        3828: '3828',
        3829: '3829',
        3830: '3830',
        3831: '3831',
        3834: '3834',
        3836: '3836',
        3838: '3838',
        3840: '3840',
        3842: '3842',
        3850: '3850',
        3860: '3860',
        3872: '3872',
        3917: '3917',
        3920: '3920',
        3923: '3923',
        3924: '3924',
        3926: '3926',
        3927: '3927',
        3929: '3929',
        3931: '3931',
        3933: '3933',
        3935: '3935',
        3941: '3941',
        3942: '3942',
        3943: '3943',
        3944: '3944',
        3949: '3949',
        3956: '3956',
        3961: '3961',
        3962: '3962',
        3963: '3963',
        3965: '3965',
        3966: '3966',
        3967: '3967',
        3969: '3969',
        3970: '3970',
        3974: '3974',
        3975: '3975',
        3983: '3983',
        3984: '3984',
        3990: '3990',
        3997: '3997',
        3998: '3998',
        3999: '3999',
        4: '4',
        4101: '4101',
        42: '42',
        4397: '4397',
        4493: '4493',
        4550: '4550',
        4575: '4575',
        4618: '4618',
        4667: '4667',
        4709: '4709',
        4710: '4710',
        4716: '4716',
        4718: '4718',
        4720: '4720',
        4721: '4721',
        4722: '4722',
        4724: '4724',
        4727: '4727',
        4728: '4728',
        4729: '4729',
        4730: '4730',
        4731: '4731',
        4732: '4732',
        4733: '4733',
        4734: '4734',
        4735: '4735',
        4736: '4736',
        4738: '4738',
        4740: '4740',
        4744: '4744',
        4745: '4745',
        4746: '4746',
        4888: '4888',
        4890: '4890',
        4898: '4898',
        4996: '4996',
        5: '5',
        526: '526',
        5278: '5278',
        5326: '5326',
        5399: '5399',
        542: '542',
        5493: '5493',
        5845: '5845',
        5900: '5900',
        5941: '5941',
        5996: '5996',
        5997: '5997',
        5998: '5998',
        5999: '5999',
        6: '6',
        6101: '6101',
        6102: '6102',
        6121: '6121',
        6183: '6183',
        6185: '6185',
        6186: '6186',
        62: '62',
        6210: '6210',
        623: '623',
        6245: '6245',
        6397: '6397',
        6420: '6420',
        6495: '6495',
        6563: '6563',
        6565: '6565',
        6568: '6568',
        6581: '6581',
        6582: '6582',
        6588: '6588',
        6590: '6590',
        6592: '6592',
        6601: '6601',
        6609: '6609',
        6614: '6614',
        6616: '6616',
        6618: '6618',
        6619: '6619',
        6636: '6636',
        6641: '6641',
        6646: '6646',
        6650: '6650',
        6654: '6654',
        6656: '6656',
        6667: '6667',
        6690: '6690',
        6692: '6692',
        6695: '6695',
        6696: '6696',
        6697: '6697',
        6698: '6698',
        6702: '6702',
        6704: '6704',
        6706: '6706',
        6709: '6709',
        6710: '6710',
        6711: '6711',
        6712: '6712',
        6713: '6713',
        6714: '6714',
        6715: '6715',
        6720: '6720',
        6721: '6721',
        6741: '6741',
        6889: '6889',
        6890: '6890',
        6892: '6892',
        6894: '6894',
        6895: '6895',
        6896: '6896',
        6897: '6897',
        6898: '6898',
        6901: '6901',
        6902: '6902',
        6903: '6903',
        6904: '6904',
        6905: '6905',
        6908: '6908',
        6912: '6912',
        6915: '6915',
        6929: '6929',
        6941: '6941',
        6996: '6996',
        6997: '6997',
        6998: '6998',
        7: '7',
        7070: '7070',
        7072: '7072',
        7101: '7101',
        7102: '7102',
        7121: '7121',
        7141: '7141',
        7142: '7142',
        7185: '7185',
        7186: '7186',
        72: '72',
        7209: '7209',
        7225: '7225',
        7308: '7308',
        7366: '7366',
        7368: '7368',
        7392: '7392',
        7393: '7393',
        7395: '7395',
        7397: '7397',
        7494: '7494',
        7495: '7495',
        7550: '7550',
        7551: '7551',
        7552: '7552',
        7554: '7554',
        7556: '7556',
        7557: '7557',
        7558: '7558',
        7563: '7563',
        7565: '7565',
        7566: '7566',
        7567: '7567',
        7568: '7568',
        7569: '7569',
        7570: '7570',
        7571: '7571',
        7572: '7572',
        7573: '7573',
        7574: '7574',
        7575: '7575',
        7576: '7576',
        7577: '7577',
        7578: '7578',
        7580: '7580',
        7582: '7582',
        7586: '7586',
        7588: '7588',
        7589: '7589',
        7590: '7590',
        7592: '7592',
        7594: '7594',
        7595: '7595',
        7596: '7596',
        7598: '7598',
        7600: '7600',
        7601: '7601',
        7602: '7602',
        7604: '7604',
        7606: '7606',
        7607: '7607',
        7608: '7608',
        7610: '7610',
        7612: '7612',
        7613: '7613',
        7614: '7614',
        7616: '7616',
        7618: '7618',
        7619: '7619',
        7620: '7620',
        7621: '7621',
        7623: '7623',
        7624: '7624',
        7626: '7626',
        7628: '7628',
        7632: '7632',
        7641: '7641',
        7644: '7644',
        7646: '7646',
        7650: '7650',
        7652: '7652',
        7654: '7654',
        7655: '7655',
        7656: '7656',
        7658: '7658',
        7660: '7660',
        7661: '7661',
        7663: '7663',
        7665: '7665',
        7667: '7667',
        7668: '7668',
        7669: '7669',
        7670: '7670',
        7671: '7671',
        7672: '7672',
        7676: '7676',
        7677: '7677',
        7678: '7678',
        7681: '7681',
        7685: '7685',
        7700: '7700',
        7702: '7702',
        7706: '7706',
        7712: '7712',
        7744: '7744',
        7745: '7745',
        7836: '7836',
        7890: '7890',
        7898: '7898',
        7912: '7912',
        7941: '7941',
        7950: '7950',
        7956: '7956',
        7958: '7958',
        7987: '7987',
        7996: '7996',
        8: '8',
        82: '82',
        8500: '8500',
        8502: '8502',
        8504: '8504',
        8505: '8505',
        8506: '8506',
        8507: '8507',
        8508: '8508',
        8509: '8509',
        8510: '8510',
        8512: '8512',
        8956: '8956',
        8996: '8996',
        8997: '8997',
        9: '9',
        91: '91',
        9122: '9122',
        9162: '9162',
        92: '92',
        9270: '9270',
        9278: '9278',
        9340: '9340',
        9395: '9395',
        9542: '9542',
        9685: '9685',
        9900: '9900',
        9923: '9923',
        9935: '9935',
        9941: '9941',
        9965: '9965',
        9990: '9990',
        9996: '9996',
        9997: '9997',
        9998: '9998',
    },
    orderUnits: {
        package: 'package',
        single: 'single',
        weight: 'weight',
    },
    priceComparisonUnits: {
        unit: 'unit',
        kg: 'kg',
        liter: 'liter',
    },
    alcoholTaxClasses: {
        Alcoholfree: 'Alcoholfree',
        Beer: 'Beer',
        Wine: 'Wine',
        MidRange: 'MidRange',
        Spirits: 'Spirits',
    },
    shelfLives: {
        short: 'short',
        medium: 'medium',
        long: 'long',
        special: 'special',
    },
    containers: {
        Can: 'Can',
        Bottle: 'Bottle',
        Keg: 'Keg',
        Tetra: 'Tetra',
        Paper: 'Paper',
        BIB: 'BIB',
        Bag: 'Bag',
        Pet: 'Pet',
        Box: 'Box',
        Pot: 'Pot',
        Carton: 'Carton',
        'Plastic can': 'Plastic can',
        TinCan: 'TinCan',
        'Vacuum-sealed': 'Vacuum-sealed',
        Other: 'Other',
    },
    recycleTypes: {
        none: 'none',
        PET1: 'PET1',
        PET2: 'PET2',
        aluminiumCan: 'aluminiumCan',
        glassBottle33cl: 'glassBottle33cl',
        glassBottle50cl: 'glassBottle50cl',
        other: 'other',
    },
    recycleTypeContainers: {
        none: 'none',
        recyclableQuarterTray: 'recyclableQuarterTray',
        trayLarge: 'trayLarge',
    },
    recycleTypePallets: {
        none: 'none',
        recyclableGreySrsPlasticPallet: 'recyclableGreySrsPlasticPallet',
        recyclableWoodenHalfPallet: 'recyclableWoodenHalfPallet',
        recyclableEuroWoodPallet: 'recyclableEuroWoodPallet',
        recyclableBPallet: 'recyclableBPallet',
        recyclableAPallet: 'recyclableAPallet',
        recylablePlasticPallet: 'recylablePlasticPallet',
        reyclingFeePlasticPallet: 'reyclingFeePlasticPallet',
        recyclablePlasticHalfPallet: 'recyclablePlasticHalfPallet',
        greySrsPlasticPallet: 'greySrsPlasticPallet',
        srsBox: 'srsBox',
        srsBox2: 'srsBox2',
    },
    storageTemperatures: {
        frozen: 'frozen',
        refrigerated: 'refrigerated',
    },
    seals: {
        'CROWN CORK CAP': 'CROWN CORK CAP',
        'GLASS CAP': 'GLASS CAP',
        'NATURAL CORK': 'NATURAL CORK',
        'SCREW CAP': 'SCREW CAP',
        'SYNTHETIC CORK': 'SYNTHETIC CORK',
        UNCLASSIFIED: 'UNCLASSIFIED',
        UNIDENTIFIED: 'UNIDENTIFIED',
    },
    salesAccounts: {
        3005: '3005',
        3004: '3004',
        3011: '3011',
        3010: '3010',
        3017: '3017',
        3014: '3014',
        3000: '3000',
    },
    knNumbers: {
        15071010: '15071010',
        15079010: '15079010',
        15081010: '15081010',
        15089010: '15089010',
        15092000: '15092000',
        15093000: '15093000',
        15094000: '15094000',
        15099000: '15099000',
        15101000: '15101000',
        15109000: '15109000',
        15111010: '15111010',
        15119011: '15119011',
        15119019: '15119019',
        15119091: '15119091',
        15121110: '15121110',
        15121910: '15121910',
        15122110: '15122110',
        15122910: '15122910',
        15131110: '15131110',
        15131911: '15131911',
        15131919: '15131919',
        15131930: '15131930',
        15132110: '15132110',
        15132911: '15132911',
        15132919: '15132919',
        15132930: '15132930',
        15141110: '15141110',
        15141910: '15141910',
        15149110: '15149110',
        15149910: '15149910',
        15151100: '15151100',
        15151910: '15151910',
        15152110: '15152110',
        15152910: '15152910',
        15153090: '15153090',
        15155011: '15155011',
        15155091: '15155091',
        15156011: '15156011',
        15156060: '15156060',
        15159011: '15159011',
        15159021: '15159021',
        15159031: '15159031',
        15159040: '15159040',
        15159060: '15159060',
        15161010: '15161010',
        15161090: '15161090',
        15162010: '15162010',
        15162091: '15162091',
        15162095: '15162095',
        15163091: '15163091',
        15171010: '15171010',
        15171090: '15171090',
        15179010: '15179010',
        15179091: '15179091',
        15179093: '15179093',
        15179099: '15179099',
        15180010: '15180010',
        15180031: '15180031',
        15180039: '15180039',
        15180095: '15180095',
        22030001: '22030001',
        22030009: '22030009',
        22030010: '22030010',
        22041011: '22041011',
        22041013: '22041013',
        22041015: '22041015',
        22041091: '22041091',
        22041093: '22041093',
        22041094: '22041094',
        22041096: '22041096',
        22041098: '22041098',
        22042106: '22042106',
        22042107: '22042107',
        22042108: '22042108',
        22042109: '22042109',
        22042111: '22042111',
        22042112: '22042112',
        22042113: '22042113',
        22042117: '22042117',
        22042118: '22042118',
        22042119: '22042119',
        22042122: '22042122',
        22042123: '22042123',
        22042124: '22042124',
        22042126: '22042126',
        22042127: '22042127',
        22042128: '22042128',
        22042131: '22042131',
        22042132: '22042132',
        22042134: '22042134',
        22042136: '22042136',
        22042137: '22042137',
        22042138: '22042138',
        22042142: '22042142',
        22042143: '22042143',
        22042144: '22042144',
        22042146: '22042146',
        22042147: '22042147',
        22042148: '22042148',
        22042161: '22042161',
        22042162: '22042162',
        22042166: '22042166',
        22042167: '22042167',
        22042168: '22042168',
        22042169: '22042169',
        22042171: '22042171',
        22042174: '22042174',
        22042176: '22042176',
        22042177: '22042177',
        22042178: '22042178',
        22042179: '22042179',
        22042180: '22042180',
        22042181: '22042181',
        22042182: '22042182',
        22042183: '22042183',
        22042184: '22042184',
        22042185: '22042185',
        22042186: '22042186',
        22042187: '22042187',
        22042188: '22042188',
        22042189: '22042189',
        22042190: '22042190',
        22042191: '22042191',
        22042193: '22042193',
        22042194: '22042194',
        22042195: '22042195',
        22042196: '22042196',
        22042197: '22042197',
        22042198: '22042198',
        22042210: '22042210',
        22042222: '22042222',
        22042223: '22042223',
        22042224: '22042224',
        22042226: '22042226',
        22042227: '22042227',
        22042228: '22042228',
        22042232: '22042232',
        22042233: '22042233',
        22042238: '22042238',
        22042278: '22042278',
        22042279: '22042279',
        22042280: '22042280',
        22042281: '22042281',
        22042282: '22042282',
        22042283: '22042283',
        22042284: '22042284',
        22042285: '22042285',
        22042286: '22042286',
        22042288: '22042288',
        22042290: '22042290',
        22042291: '22042291',
        22042293: '22042293',
        22042294: '22042294',
        22042295: '22042295',
        22042296: '22042296',
        22042297: '22042297',
        22042298: '22042298',
        22042910: '22042910',
        22042922: '22042922',
        22042923: '22042923',
        22042924: '22042924',
        22042926: '22042926',
        22042927: '22042927',
        22042928: '22042928',
        22042932: '22042932',
        22042938: '22042938',
        22042978: '22042978',
        22042979: '22042979',
        22042980: '22042980',
        22042981: '22042981',
        22042982: '22042982',
        22042983: '22042983',
        22042984: '22042984',
        22042985: '22042985',
        22042986: '22042986',
        22042988: '22042988',
        22042990: '22042990',
        22042991: '22042991',
        22042993: '22042993',
        22042994: '22042994',
        22042995: '22042995',
        22042996: '22042996',
        22042997: '22042997',
        22042998: '22042998',
        22043010: '22043010',
        22043096: '22043096',
        22043098: '22043098',
        22051010: '22051010',
        22051090: '22051090',
        22059010: '22059010',
        22059090: '22059090',
        22060010: '22060010',
        22060031: '22060031',
        22060039: '22060039',
        22060051: '22060051',
        22060059: '22060059',
        22060081: '22060081',
        22060089: '22060089',
        22071000: '22071000',
        22072000: '22072000',
        22082012: '22082012',
        22082014: '22082014',
        22082016: '22082016',
        22082018: '22082018',
        22082019: '22082019',
        22082026: '22082026',
        22082028: '22082028',
        22082062: '22082062',
        22082066: '22082066',
        22082069: '22082069',
        22082086: '22082086',
        22082088: '22082088',
        22083011: '22083011',
        22083019: '22083019',
        22083030: '22083030',
        22083041: '22083041',
        22083049: '22083049',
        22083061: '22083061',
        22083069: '22083069',
        22083071: '22083071',
        22083079: '22083079',
        22083082: '22083082',
        22083088: '22083088',
        22084011: '22084011',
        22084031: '22084031',
        22084039: '22084039',
        22084051: '22084051',
        22084091: '22084091',
        22084099: '22084099',
        22085011: '22085011',
        22085019: '22085019',
        22085091: '22085091',
        22085099: '22085099',
        22086011: '22086011',
        22086019: '22086019',
        22086091: '22086091',
        22086099: '22086099',
        22087010: '22087010',
        22087090: '22087090',
        22089011: '22089011',
        22089019: '22089019',
        22089033: '22089033',
        22089038: '22089038',
        22089041: '22089041',
        22089045: '22089045',
        22089048: '22089048',
        22089054: '22089054',
        22089056: '22089056',
        22089069: '22089069',
        22089071: '22089071',
        22089075: '22089075',
        22089077: '22089077',
        22089078: '22089078',
        22089091: '22089091',
        22089099: '22089099',
        24021000: '24021000',
        24022010: '24022010',
        24022090: '24022090',
        24029000: '24029000',
        24031100: '24031100',
        24031910: '24031910',
        24031990: '24031990',
        24039100: '24039100',
        24039990: '24039990',
        27071000: '27071000',
        27072000: '27072000',
        27073000: '27073000',
        27075000: '27075000',
        27101211: '27101211',
        27101215: '27101215',
        27101221: '27101221',
        27101225: '27101225',
        27101231: '27101231',
        27101241: '27101241',
        27101245: '27101245',
        27101249: '27101249',
        27101250: '27101250',
        27101270: '27101270',
        27101290: '27101290',
        27101911: '27101911',
        27101915: '27101915',
        27101921: '27101921',
        27101925: '27101925',
        27101929: '27101929',
        27101931: '27101931',
        27101935: '27101935',
        27101943: '27101943',
        27101946: '27101946',
        27101947: '27101947',
        27101948: '27101948',
        27101951: '27101951',
        27101955: '27101955',
        27101962: '27101962',
        27101966: '27101966',
        27101967: '27101967',
        27102011: '27102011',
        27102016: '27102016',
        27102019: '27102019',
        27102032: '27102032',
        27102038: '27102038',
        27102090: '27102090',
        27111211: '27111211',
        27111219: '27111219',
        27111291: '27111291',
        27111293: '27111293',
        27111294: '27111294',
        27111297: '27111297',
        27111310: '27111310',
        27111330: '27111330',
        27111391: '27111391',
        27111397: '27111397',
        27111400: '27111400',
        27111900: '27111900',
        29011000: '29011000',
        29022000: '29022000',
        29023000: '29023000',
        29024100: '29024100',
        29024200: '29024200',
        29024300: '29024300',
        29024400: '29024400',
        29051100: '29051100',
        38111110: '38111110',
        38111190: '38111190',
        38111900: '38111900',
        38119000: '38119000',
        38248900: '38248900',
        38249200: '38249200',
        38249986: '38249986',
        38249992: '38249992',
        38249993: '38249993',
        38249996: '38249996',
        38260010: '38260010',
        38260090: '38260090',
    },
    exciseProductCodes: {
        B000: 'B000',
        W200: 'W200',
        W300: 'W300',
        I000: 'I000',
        S200: 'S200',
        S300: 'S300',
        S400: 'S400',
        S500: 'S500',
        S600: 'S600',
    },
    preparationFormats: {
        'Loose Leaf': 'Loose Leaf',
        'Tea Bag': 'Tea Bag',
        'Instant Tea': 'Instant Tea',
        'Ready-to-drink': 'Ready-to-drink',
        'Instant Coffee': 'Instant Coffee',
        'Coffee Pod': 'Coffee Pod',
        Powder: 'Powder',
        Concentrate: 'Concentrate',
        Brewed: 'Brewed',
        'Freeze-dried': 'Freeze-dried',
        Other: 'Other',
    },
    articleBatches: {},
    articleLinks: {},
    stockKeepingUnits: {
        names: {
            lav: 'lav',
            bag_in_box: 'bag_in_box',
            PET: 'PET',
            pallet: 'pallet',
            package: 'package',
            pcs: 'pcs',
            kg: 'kg',
            hg: 'hg',
            g: 'g',
            liter: 'liter',
            dl: 'dl',
            cl: 'cl',
            ml: 'ml',
            case: 'case',
            crate: 'crate',
            bale: 'bale',
            big_box: 'big_box',
            piece: 'piece',
            block: 'block',
            book: 'book',
            tray: 'tray',
            bouquet: 'bouquet',
            bundle: 'bundle',
            can: 'can',
            tub: 'tub',
            mug: 'mug',
            big_can: 'big_can',
            disposable_glass: 'disposable_glass',
            barrel: 'barrel',
            package4: 'package4',
            bottle: 'bottle',
            braid: 'braid',
            package2: 'package2',
            glass: 'glass',
            bucket: 'bucket',
            keg: 'keg',
            capsules: 'capsules',
            sv_karta: 'sv_karta',
            carton: 'carton',
            cassette: 'cassette',
            bunch: 'bunch',
            bundle2: 'bundle2',
            basket: 'basket',
            pot: 'pot',
            quarter_pallet: 'quarter_pallet',
            box: 'box',
            bulk: 'bulk',
            m: 'm',
            m2: 'm2',
            net: 'net',
            package3: 'package3',
            package5: 'package5',
            bag: 'bag',
            recycle_glass: 'recycle_glass',
            roll: 'roll',
            side: 'side',
            sack: 'sack',
            tetra: 'tetra',
            trough: 'trough',
            tube: 'tube',
            wagon: 'wagon',
            unknown: 'unknown',
        },
    },
};
